import { useEffect, useState } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { getManagedCustomers, setCustomerStatus } from '../services/adminCustomerControlsService';

const { FiPauseCircle, FiRotateCcw, FiTrash2 } = FiIcons;

function AdminCustomersPanel() {
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState('');

  const load = async () => {
    try {
      setCustomers(await getManagedCustomers());
    } catch (error) {
      setMessage(error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); }, []);

  const changeStatus = async (customer, status) => {
    const verb = status === 'removed' ? 'remove from the active customer list' : status;
    if (!window.confirm(`Are you sure you want to ${verb} ${customer.full_name}? Historical orders will be kept.`)) return;
    try {
      await setCustomerStatus(customer.id, status);
      setMessage(`Customer status updated to ${status}.`);
      await load();
    } catch (error) {
      setMessage(error.message);
    }
  };

  return (
    <div className="admin-overview-container">
      <div className="admin-page-header">
        <div>
          <h1 className="admin-page-title">Customers</h1>
          <p className="admin-page-subtitle">Customer contacts from active orders.</p>
        </div>
      </div>
      {message && <div className="admin-alert info">{message}</div>}
      {loading ? <div className="admin-loading-state">Loading customers…</div> : (
        <div className="admin-product-table-card">
          <table className="admin-table">
            <thead>
              <tr><th>Name</th><th>Email</th><th>Phone</th><th>Registered</th><th>Status</th><th>Actions</th></tr>
            </thead>
            <tbody>
              {customers.map((customer) => (
                <tr key={customer.id}>
                  <td><strong>{customer.full_name}</strong></td>
                  <td>{customer.email}</td>
                  <td><a href={`tel:${customer.phone}`}>{customer.phone}</a></td>
                  <td>{new Date(customer.created_at).toLocaleDateString()}</td>
                  <td>{customer.admin_status || 'active'}</td>
                  <td>
                    <div className="table-btn-group">
                      {customer.admin_status !== 'suspended' && (
                        <button className="table-action-btn edit" onClick={() => changeStatus(customer, 'suspended')}>
                          <SafeIcon icon={FiPauseCircle} /> Suspend
                        </button>
                      )}
                      {customer.admin_status !== 'active' && (
                        <button className="table-action-btn edit" onClick={() => changeStatus(customer, 'active')}>
                          <SafeIcon icon={FiRotateCcw} /> Restore
                        </button>
                      )}
                      {customer.admin_status !== 'removed' && (
                        <button className="table-action-btn delete" onClick={() => changeStatus(customer, 'removed')}>
                          <SafeIcon icon={FiTrash2} /> Remove
                        </button>
                      )}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

export default AdminCustomersPanel;